export default __webpack_public_path__ + "static/media/bg-left-scale.f6e28a58.svg";